import React from 'react';
import { useTranslation } from 'react-i18next';
import PostCards from '../PostCards/PostCards';
import './SearchResults.css';

function SearchResults({ products, viewMode = 'grid' }) {
  const { t } = useTranslation();
  if (!products || products.length === 0) {
    return (
      <div className="searchResultsEmpty">
        <p>{t('ui.noResultsFound')}</p>
        <p className="searchResultsEmptyHint">
          {t('ui.tryDifferentKeywords')}
        </p>
      </div>
    );
  }

  const className =
    viewMode === 'list' ? 'searchResultsList' : 'searchResultsGrid';
  return (
    <div className={className}>
      {products.map((product, index) => (
        <div className="searchResultCard" key={product.id || index}>
          <PostCards product={product} index={index} />
        </div>
      ))}
    </div>
  );
}

export default SearchResults;
